<template v-if="selectedFeatures && selectedFeatures.length">
    <AdvancedMarker v-for="(feature, index) in selectedFeatures" :key="index" :options="feature.markerOptions">
    <InfoWindow>
        <p id="infoWindowTitle">{{feature.name}}</p>
        <p id="infoWindowDescription" v-html="feature.description"></p>
    </InfoWindow>
    </AdvancedMarker>
</template>

<script setup>
import {ref, defineProps, watch} from 'vue'
import {AdvancedMarker, InfoWindow} from "vue3-google-map"

const props = defineProps({
    selectedFeatures: Array
})

const selectedFeatures = ref(props.selectedFeatures)

watch(() => props.selectedFeatures, (newSelected) => {
  selectedFeatures.value = newSelected
})


</script>

<style>
/* this class is applied to marker elements in MapFeatureSelection.vue*/
.feature-marker {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
}

.feature-marker img{
    width: 30px;
    height: 30px;
}

#infoWindowTitle {
  font-weight: bold;
  font-size: 20px;
}

#infoWindowDescription {
  font-size: 16px;
}
</style>